import Vue from 'vue';
import Router from 'vue-router';
import {getStore} from "@/utils/storage";

Vue.use(Router);

const routes = [
    {
        path: '/',
        redirect: '/login'
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('./view/login'),
        meta: {
            // title: '体温打卡，中国加油！',
            title: '绑定授权',
            no_login: true
        }
    },
    {
        path: '/index',
        name: 'index',
        component: () => import('./view/index/index'),
        meta: {
            title: '体温打卡，中国加油！'
        }
    },
    {
        path: '/clock',
        name: 'clock',
        component: () => import('./view/staff/clock'),
        meta: {
            title: '订单记录'
        }
    },
    {
        path: '/store',
        name: 'store',
        component: () => import('./view/store/index'),
        meta: {
            title: '发货明细&库存详情'
        }
    },
    {
        path: '/storeRecord',
        name: 'storeRecord',
        component: () => import('./view/store_record/index'),
        meta: {
            title: '订单记录'
        }
    },
    {
        path: '/noPhone',
        name: 'noPhone',
        component: () => import('./view/store_record/noPhone'),
        meta: {
            title: '产品说明'
        }
    },
];

// add route path
routes.forEach(route => {
    route.path = route.path || '/' + (route.name || '');
});

const router = new Router(
    {
        mode: 'history',
        routes
    });
const whiteList = [
    'login',
    'stafflogin',
    'invitation',
    'next',
    'join',
    'xiapu',
    'talentExchange',
    'captcha',
    'store',
    'storeRecord',
    'noPhone'
]
router.beforeEach((to, from, next) => {
    const title = to.meta && to.meta.title;
    if (title) {
        document.title = title;
    }

    if (whiteList.includes(to.name)) {
        if (to.name === 'talentExchange') {
            const body = document.getElementsByTagName('body')[0];
            body.style.background = '#f5f5f5'
            body.style.height = '100%'
        }
        if (to.name === 'captcha') {
            var hm = document.createElement("script");
            hm.src = "https://ssl.captcha.qq.com/TCaptcha.js";
            var s = document.getElementsByTagName("script")[0];
            s.parentNode.appendChild(hm);
        }
        next()
    } else {
        if (getStore('phone')) {
            next()
        } else {
            next({name: 'login'})
        }
    }

});

export {
    router
};
